export const TEMPLATES = {
  MEA: 'mea',
  default: 'classic'
};
